import React from 'react';
import { Button, Result } from 'antd';
import i18n from '../i18n';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
          <Result
            status="error"
            title={i18n.t('errorBoundary.title')}
            subTitle={i18n.t('errorBoundary.message')}
            extra={
              <Button type="primary" onClick={() => window.location.reload()}>
                {i18n.t('errorBoundary.reload')}
              </Button>
            }
          />
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
